import {PermissionList} from '../enum/appPermissions';
const getDerivedUserData = (data) => {
  let isUserAdmin = false;
  let isStandardUser = false;
  data.forEach((permission) => {
    isUserAdmin =
      isUserAdmin ||
      [PermissionList.ADMIN_ACCESS_READ, PermissionList.ADMIN_ACCESS_WRITE].includes(permission?.permissionName);
    isStandardUser = isStandardUser || [PermissionList.PHOENIX_READ].includes(permission?.permissionName);
  });
  return {
    isUserAdmin,
    isStandardUser,
  };
};

export {getDerivedUserData};
